import React, { useState, useEffect } from "react";
import Moment from "moment";

// Redux
import { connect } from "react-redux";

import PropTypes from "prop-types";
import genericAction from "@Actions/generic";

// Components
import Text from "@Components/Text";
import { Button, Checkbox, Dropdown, Form, Label, Icon, Grid } from "semantic-ui-react";
import Input from "@Components/Input";
import { dropdownFormat } from "@Utils/formats";
import IKModal from "@Components/IkModal";
import InputFilter from "@Components/InputFilter";
import TextAreaInput from "@Components/TextArea";

// Lodash
import { isEmpty, map, concat, split, find, isArray, includes } from "lodash";

// staticData
import {
	contactOption,
	orderByOptionsDetailed,
	orderByOptions,
	orderByOptionsResumidas,
	orderByOptionsHoraUsuarios,
	orderByOptionsHoraGrupos,
	dropdownOptions,
} from "./staticData";

// Styles
import styles from "./styles.module.css";

const ActionUserCrud = ({
	onClose,
	dispatch,
	setPlatformfilters,
	groupsfilters,
	setGroupsfilters,
	tagsSelected,
	setTagsSelected,
	categoriesSelected,
	setCategoriesSelected,
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	contacts,
	setContacts,
	agents,
	setAgents,
	note,
	setNote,
	options,
	setSeletedFilteres,
	seletedFilteres,
	dateField,
	setDateField,
	onApplyFilters,
	channelFilters,
	setChannelFilters,
	channels,
	setTabValue,
	stateValue,
	setStateValue,
	orderBy,
	setOrderBy,
	orderDirection,
	setOrderDirection,
	includeClosed: includeClosedProp,
	setIncludeClosed: setIncludeClosedProp,
	originValue,
	setOriginValue,
}) => {
	const [channelfiltersData, setChannelfiltersData] = useState([]);
	const [channelAll, setChannelAll] = useState(false);
	const [groupsAll, setGroupsAll] = useState(false);
	const [groupsData, setGroupsData] = useState([]);
	const [agentsData, setAgentsData] = useState([]);
	const [tagsData, setTagsData] = useState([]);
	const [categoriesData, setCategoriesData] = useState([]);
	const [cleaned, setCleaned] = useState(false);
	const [filtersByReportType, setFiltersByReportType] = useState({});
	const [selectedFilterTemp, setSelectedFilterTemp] = useState(seletedFilteres || "Detalladas");
	const [tempOrderBy, setTempOrderBy] = useState(orderBy || "");
	const [tempOrderDirection, setTempOrderDirection] = useState(orderDirection || "");
	const [includeClosedLocal, setIncludeClosedLocal] = useState(includeClosedProp ?? true);
	const includeClosed = typeof includeClosedProp === "boolean" ? includeClosedProp : includeClosedLocal;
	const setIncludeClosed = setIncludeClosedProp || setIncludeClosedLocal;
	const [errors, setErrors] = useState({ platformfilters: "", selected: "" });

	const orderDirectionOptions = (find(orderByOptions, { key: "orderDirection" }) || {}).options || [];

	useEffect(() => {
		(async () => {
			const usersPromise = dispatch(genericAction({ method: "get", route: "users/all" }));
			const tagsPromise = dispatch(genericAction({ method: "get", route: "tags/all" }));
			const groupPromise = dispatch(genericAction({ method: "get", route: "groups/all" }));
			const categoriesPromise = dispatch(genericAction({ method: "get", route: "category/all" }));
			const [usersResponse, tagsResponse, groupResponse, categoriesResponse] = await Promise.all([
				usersPromise,
				tagsPromise,
				groupPromise,
				categoriesPromise,
			]);
			const platoformsMapped = map(channels, (item) => {
				return {
					key: item.id,
					text: item.label.toLowerCase(),
					value: item.id,
				};
			});

			const groupsMapped = dropdownFormat(groupResponse, "name", "id");
			groupsMapped.unshift({ key: "*", text: "Sin grupo", value: "*" });
			setGroupsData(groupsMapped);

			setChannelfiltersData(platoformsMapped);
			setAgentsData(dropdownFormat(usersResponse, "user.fullName", "userId"));
			setTagsData(
				map(tagsResponse, (item) => {
					return {
						key: item.id,
						text: item.name,
						value: item.id,
						categoryId: item.categoryId,
					};
				})
			);
			setCategoriesData(dropdownFormat(categoriesResponse, "name", "id"));
		})();
	}, []);

	const checkAll = (name) => {
		switch (name) {
			case "channelFilters":
				if (!channelAll) {
					const allChannelIds = map(channels, (item) => {
						return item.id;
					});
					setChannelFilters(allChannelIds);
					setChannelAll(true);
				} else {
					setChannelFilters([]);
					setChannelAll(false);
				}
				break;
			case "groupsfilters":
				if (!groupsAll) {
					const allGroupIds = map(groupsData, (item) => {
						return item.value;
					});
					setGroupsfilters(allGroupIds);
					setGroupsAll(true);
				} else {
					setGroupsfilters([]);
					setGroupsAll(false);
				}
				break;
			default:
				break;
		}
	};

	const handleInput = (e) => {
		const { name, value } = e.target;
		if (name === "startDate") {
			setStartDate(value);
		} else {
			setEndDate(value);
		}
	};

	const handleTipyfication = (name, data) => {
		setTagsSelected(data);
	};

	const handleCategorySelection = (e, { value }) => {
		setCategoriesSelected(value);
	};

	const onFilter = () => {
		const contactId = contacts?.id || null;
		const errorsTest = {};

		const noFieldsSelected =
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(categoriesSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters) &&
			isEmpty(selectedFilterTemp);

		const onlyReportType =
			!isEmpty(selectedFilterTemp) &&
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(categoriesSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelFilters);

		if (noFieldsSelected) {
			errorsTest.selected = "Debe seleccionar mínimo un campo";
			setErrors(errorsTest);
			return;
		}

		if (onlyReportType) {
			errorsTest.selected = "Seleccione al menos otro campo además del tipo de reporte";
			setErrors(errorsTest);
			return;
		}

		if (isEmpty(selectedFilterTemp)) {
			errorsTest.selected = "Debe seleccionar un tipo de reporte";
			setErrors(errorsTest);
			return;
		}

		if (tempOrderBy && !tempOrderDirection) {
			errorsTest.selected = "Si selecciona 'Ordenar por', también debe seleccionar 'Ascendente' o 'Descendente'.";
			setErrors(errorsTest);
			return;
		}

		setErrors({});
		const filters = {};

		if (contactId) filters.contactId = contactId;
		if (!isEmpty(agents)) {
			filters["userId[]"] = concat([], agents);
		}
		if (!isEmpty(groupsfilters)) {
			if (groupsfilters.includes("*")) {
				filters["groupId&*"] = 0;
			} else {
				filters["groupId[]"] = concat([], groupsfilters);
			}
		}
		if (includeClosed) {
			filters.includeClosed = true;
		}

		if (!isEmpty(tagsSelected)) {
			if (selectedFilterTemp === "Etiquetas") {
				filters["tagId[]"] = concat([], tagsSelected);
			} else {
				filters.tags = tagsSelected;
			}
		}
		if (!isEmpty(categoriesSelected)) {
			if (selectedFilterTemp === "Etiquetas") {
				filters["tag.categoryId[]"] = categoriesSelected;
			} else {
				filters["tags.categoryId[]"] = categoriesSelected;
			}
		}
		if (note) filters.text = note;
		if (!isEmpty(channelFilters)) {
			filters["channelId[]"] = concat([], channelFilters);
		}
		if (dateField && (startDate || endDate)) {
			const start = startDate || "";
			const end = endDate || "";
			filters[dateField] = `${start},${end}`;
		}

		if (tempOrderBy) {
			filters.orderKey = tempOrderBy;
			if (setOrderBy) setOrderBy(tempOrderBy);
		}
		if (tempOrderDirection) {
			filters.orderDir = tempOrderDirection;
			if (setOrderDirection) setOrderDirection(tempOrderDirection);
		}

		if (selectedFilterTemp === "Detalladas") {
			if (stateValue) filters.closeState = stateValue;
			if (!isEmpty(originValue)) filters["origin[]?"] = originValue;
		}
		filters.includeClosed = includeClosed;

		setFiltersByReportType((prev) => {
			return {
				...prev,
				[selectedFilterTemp]: filters,
			};
		});

		if (onApplyFilters) {
			setSeletedFilteres(selectedFilterTemp);
			onApplyFilters(filters);
		}
		onClose();
	};

	useEffect(() => {
		const filters = filtersByReportType[selectedFilterTemp];
		if (filters) {
			setAgents(filters.userId || []);
			setContacts(filters.contactId ? { id: filters.contactId } : {});
			setGroupsfilters(filters.groups || []);
			setTagsSelected(filters.tag || filters.tags || []);
			setCategoriesSelected(filters["tag.categoryId[]"] || filters["tags.categoryId[]"] || filters.categories || []);
			setNote(filters.text || "");
			setPlatformfilters(filters.platforms || []);
			setIncludeClosed(filters.includeClosed === true || filters.includeClosed === "true" ? true : includeClosedProp ?? true);
			setStateValue(filters.closeState || "");
			setOriginValue(filters["origin[]"] || []);

			if (filters.createdDate || filters.closeDate) {
				const range = filters.createdDate || filters.closeDate;
				const [start, end] = split(range, ",");
				setStartDate(start);
				setEndDate(end);
				setDateField(filters.createdDate ? "createdDate" : "closeDate");
			}
		}
	}, [selectedFilterTemp]);

	useEffect(() => {
		setIncludeClosed(includeClosedProp ?? true);
	}, [includeClosedProp]);

	const onChangeDropdown = (value, name) => {
		if (name === "channelFilters") {
			setChannelFilters(value);
			if (channelfiltersData.length === value.length) {
				setChannelAll(true);
			} else {
				setChannelAll(false);
			}
		} else if (name === "groupsfilters") {
			setGroupsfilters(value);
			if (groupsData.length === value.length) {
				setGroupsAll(true);
			} else {
				setGroupsAll(false);
			}
		}
	};

	const onContactsSelect = (item) => {
		setContacts(item);
	};
	const onContactsRemove = () => {
		setContacts({});
	};
	const renderLabelPlatforms = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const renderLabelDepartments = (label) => {
		return {
			color: "blue",
			content: `${label.text} `,
			icon: "building outline",
		};
	};
	const cleanModal = () => {
		setAgents([]);
		setContacts("");
		setPlatformfilters([]);
		setChannelFilters([]);
		setGroupsfilters([]);
		setTagsSelected([]);
		setCategoriesSelected([]);
		setStartDate(Moment().format("YYYY-MM-DD"));
		setEndDate("");
		setNote("");
		setGroupsAll(false);
		setChannelAll(false);
		setErrors({ platformfilters: "", selected: "" });
		setSeletedFilteres("");
		setSelectedFilterTemp("Detalladas");
		setTempOrderBy("");
		setTempOrderDirection("");
		setStateValue("");
		setOriginValue([]);
		setIncludeClosed(true);
		setCleaned(true);

		setTimeout(() => {
			setCleaned(false);
		}, 2000);
	};

	const handleInputDropdown = (event, { value }) => {
		setTagsSelected(value);
	};

	const onChangeSelection = (e, { value }) => {
		setSelectedFilterTemp(value);
		if (value === "Resumidas" || value === "Hora/Usuarios" || value === "Hora/Grupos") {
			setTagsSelected([]);
			setCategoriesSelected([]);
			setNote("");
		}
		if (value !== "Detalladas") {
			setTabValue("");
			setStateValue("");
		}
	};

	const getFieldsetClass = (filters, data) => {
		const safeFilters = filters || [];
		const safeData = data || [];
		if (isEmpty(safeFilters) && isEmpty(agents) && isEmpty(tagsSelected) && isEmpty(categoriesSelected)) return "";

		const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;

		if (ratio > 0.75 || !isEmpty(agents) || !isEmpty(tagsSelected) || !isEmpty(categoriesSelected)) return styles.hasMostOptions;
		if (ratio > 0.5) return styles.hasManyOptions;

		return styles.hasOptions;
	};

	const renderLabelChannels = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const handleOrderByChange = (value) => {
		setTempOrderBy(value);
		if (value === "createdDate" || value === "closeDate") {
			setDateField(value);
		}
	};

	const getOrderByOptions = () => {
		if (selectedFilterTemp === "Resumidas") return orderByOptionsResumidas;
		if (selectedFilterTemp === "Hora/Usuarios") return orderByOptionsHoraUsuarios;
		if (selectedFilterTemp === "Hora/Grupos") return orderByOptionsHoraGrupos;
		return orderByOptionsDetailed;
	};

	const usersHasMostOptions = (() => {
		const safeFilters = agents || [];
		const safeData = agentsData || [];
		const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;
		return ratio > 0.75 || !isEmpty(agents) || !isEmpty(tagsSelected) || !isEmpty(categoriesSelected);
	})();
	const channelsHasMostOptions = (() => {
		const safeFilters = channelFilters || [];
		const safeData = channelfiltersData || [];
		const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;
		return ratio > 0.75;
	})();
	// const groupsHasMostOptions = (() => {
	// 	const safeFilters = groupsfilters || [];
	// 	const safeData = groupsData || [];
	// 	const ratio = safeData.length === 0 ? 0 : safeFilters.length / safeData.length;
	// 	return ratio > 0.75;
	// })();

	return (
		<IKModal
			iconName="filter"
			title="Filtro de Conv. Chats Entrantes"
			onClose={onClose}
			onSuccess={onFilter}
			cancelLabel="Cancelar"
			saveLabel="Filtrar"
			fullHeight
			size="small">
			<Grid className={styles.grid}>
				{!isEmpty(errors.selected) && (
					<div className={styles.center}>
						<Label className={styles.labelError} basic color="red">
							{errors.selected}
						</Label>
					</div>
				)}
				<div className={styles.containerFirst}>
					<fieldset className={styles.fieldset}>
						<legend className={styles.legendWithButton}>
							<span className={styles.legend}>Filtrado</span>
							<div className={styles.clearButtonContainer}>
								<Button icon size="mini" onClick={cleanModal} className={styles.clearButtonInline}>
									<Icon name="trash alternate outline" />
									Limpiar Todo
								</Button>
								{cleaned && <span className={styles.tooltipAbove}>¡Filtros limpiados!</span>}
							</div>
						</legend>

						<div className={styles.dateFieldDate}>
							<div className={styles.rowFilters}>
								<div className={styles.userDropdownBlock2}>
									<span className={styles.lookUpLabel}>Tipo de Reporte:</span>
									<Dropdown
										className={styles.filterDropdown}
										placeholder="Selecciona un filtro"
										selection
										options={options}
										value={selectedFilterTemp}
										onChange={onChangeSelection}
										clearable
									/>
								</div>
								<div className={styles.toggleColumn}>
									<span>Incluir cerradas</span>
									<div className={styles.toggleRow}>
										<Checkbox
											toggle
											checked={includeClosed}
											label={includeClosed ? "Si" : "No"}
											onChange={(e, { checked }) => {
												return setIncludeClosed(checked);
											}}
										/>
									</div>
								</div>
							</div>
							<div className={styles.flexContainer}>
								<Input
									type="date"
									label="Desde:"
									icon="calendar minus"
									iconPosition="left"
									placeholder="Inicio"
									fluid
									size="mini"
									name="startDate"
									value={startDate}
									max={Moment().format("YYYY-MM-DD")}
									onChange={handleInput}
									className={styles.dateInput}
								/>
								<Input
									type="date"
									label="Hasta:"
									icon="calendar plus"
									iconPosition="left"
									placeholder="Final"
									fluid
									size="mini"
									name="endDate"
									value={endDate}
									min={startDate}
									max={Moment().format("YYYY-MM-DD")}
									onChange={handleInput}
									className={styles.dateInput}
								/>
							</div>
						</div>
						{!["Por Días", "Por Días", "Por Mes", "Por Horas"].includes(selectedFilterTemp) && (
							<div className={styles.containerOptions}>
								<div className={styles.containerOrder}>
									<Text className={styles.textTypificacion}>Ordenar por:</Text>
									<Dropdown
										fluid
										search
										placeholder="Seleccionar"
										options={getOrderByOptions()}
										value={tempOrderBy}
										onChange={(e, { value }) => {
											return handleOrderByChange(value);
										}}
										selection
										clearable
									/>
								</div>
								<div className={styles.containerOrder}>
									<Text className={styles.textTypificacionSpecial}>&nbsp;</Text>
									<Dropdown
										fluid
										search
										placeholder="Seleccionar"
										options={orderDirectionOptions}
										value={tempOrderDirection}
										onChange={(e, { value }) => {
											setTempOrderDirection(value);
										}}
										selection
										clearable
										error={!!errors.selected && tempOrderBy && !tempOrderDirection}
									/>
								</div>
							</div>
						)}

						{selectedFilterTemp === "Detalladas" && (
							<div className={styles.containerOptions}>
								{/* <div className={styles.containerOrder}>
									<Text className={styles.textTypificacion}>Origen:</Text>
									<Dropdown
										fluid
										search
										multiple
										placeholder="Seleccionar"
										options={find(dropdownOptions, { key: "originValue" })?.options || []}
										value={originValue}
										onChange={(e, { value }) => {
											return setOriginValue(value);
										}}
										selection
										clearable
									/>
								</div> */}
								<div className={styles.containerOrder}>
									<Text className={styles.textTypificacion}>Estado:</Text>
									<Dropdown
										fluid
										search
										placeholder="Seleccionar"
										options={find(dropdownOptions, { key: "stateValue" })?.options || []}
										value={stateValue}
										onChange={(e, { value }) => {
											return setStateValue(value);
										}}
										selection
										clearable
									/>
								</div>
							</div>
						)}
					</fieldset>
					<fieldset className={styles.fieldset}>
						<legend className={styles.legend}>Otros</legend>
						<div className={styles.contactContainer}>
							<div className={styles.lookUpLabel}>Contacto:</div>
							<InputFilter
								contactData={contacts}
								selectedContact={onContactsSelect}
								onEmpty={onContactsRemove}
								url="contacts"
								defaultField="all"
								forceInputValue="name"
								selectTitle="Buscar Contactos"
								tableColumns={contactOption}
							/>
						</div>

						<div className={styles.userContainerTags}>
							<div
								className={`${styles.userDropdownBlock} ${styles.typification} ${
									selectedFilterTemp === "Resumidas" ? styles.resumidasCompact : ""
								} ${selectedFilterTemp === "Hora/Usuarios" ? styles.resumidasCompact : ""} ${
									selectedFilterTemp === "Hora/Grupos" ? styles.resumidasCompact : ""
								} ${selectedFilterTemp === "Por Días" ? styles.resumidasCompact : ""} ${
									selectedFilterTemp === "Por Horas" ? styles.resumidasCompact : ""
								}`}>
								<Text className={styles.lookUpLabel}>Usuarios:</Text>
								<Dropdown
									fluid
									onChange={(e, { value }) => {
										return setAgents(value);
									}}
									value={agents}
									renderLabel={renderLabelPlatforms}
									multiple
									selection
									search
									clearable
								/>
							</div>
							{!isEmpty(groupsData) && (
								<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
									<div className={`${styles.contDiv} ${styles.justifySpaceBetween}`}>
										<Text className={styles.lookUpLabel} style={{ paddingBottom: 0 }}>
											Grupos:
										</Text>
										<div className={styles.flexAlignCent}>
											<Checkbox
												name="groupsAll"
												className={styles.checkBox}
												checked={groupsAll}
												onChange={() => {
													return checkAll("groupsfilters");
												}}
											/>
											<Text className={`${styles.sectionTitleText} ${styles.marginLeft05rem}`}>Todos</Text>
										</div>
									</div>
									<Dropdown
										fluid
										onChange={(e, { value }) => {
											return onChangeDropdown(value, "groupsfilters");
										}}
										placeholder="Seleccionar Grupos"
										multiple
										clearable
										search
										selection
										value={groupsfilters}
										options={groupsData}
										renderLabel={renderLabelDepartments}
									/>
								</div>
							)}
						</div>
						{selectedFilterTemp !== "Resumidas" &&
							selectedFilterTemp !== "Hora/Usuarios" &&
							selectedFilterTemp !== "Hora/Grupos" &&
							selectedFilterTemp !== "Por Dias" &&
							selectedFilterTemp !== "Por Horas" && (
								<Form className={styles.typification}>
									<Text className={styles.textTypificacion}>Texto:</Text>
									<div style={{ position: "relative" }}>
										<TextAreaInput
											value={note}
											name="messageArea"
											onChange={(e) => {
												return setNote(e.target.value);
											}}
											className={styles.inputGroupB}
											minRows={1}
											maxRows={6}
										/>
									</div>
								</Form>
							)}
					</fieldset>
				</div>
				<div className={styles.filtersContainer}>
					{!isEmpty(channelfiltersData) && (
						<fieldset
							className={`${styles.fieldsetChannel} ${!isEmpty(errors.selected) ? styles.error : ""} ${
								channelsHasMostOptions && usersHasMostOptions ? styles.hasMostOptions : getFieldsetClass(channelFilters, channelfiltersData)
							} ${styles.matchEtiquetas}`}>
							<legend className={styles.legend}>Canales</legend>
							<div className={styles.section}>
								<div className={styles.contDiv}>
									<Checkbox
										className={styles.checkBox}
										name="channelAll"
										checked={channelAll}
										onChange={() => {
											return checkAll("channelFilters");
										}}
									/>
									{!isEmpty(errors.channelfilters) && (
										<Text className={styles.ErrorChannel} color="red">
											{errors.channelfilters}
										</Text>
									)}
									<Text className={styles.sectionTitleText}>Todos</Text>
								</div>

								<div className={styles.sectionContent}>
									<Dropdown
										fluid
										onChange={(e, { value }) => {
											return onChangeDropdown(value, "channelFilters");
										}}
										value={channelFilters}
										placeholder="Seleccionar"
										multiple
										clearable
										search
										selection
										options={channelfiltersData}
										renderLabel={renderLabelChannels}
										upward
									/>
								</div>
							</div>
						</fieldset>
					)}
					<fieldset
						className={`${styles.fieldsetGroup} ${!isEmpty(errors.selected) ? styles.error : ""} ${getFieldsetClass(
							tagsSelected,
							tagsData
						)}`}>
						<legend className={styles.legend}>Etiquetas</legend>
						<div className={styles.sectionContent}>
							<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
								<Text className={styles.lookUpLabel}>Por Categoría:</Text>
								<Dropdown
									fluid
									name="categoriesSelected"
									value={categoriesSelected}
									onChange={handleCategorySelection}
									options={categoriesData}
									placeholder="Seleccionar"
									size="mini"
									search
									multiple
									selection
									clearable
									renderLabel={renderLabelPlatforms}
									upward
								/>
							</div>
							<div className={`${styles.userDropdownBlock} ${styles.typification} ${styles.marginTop1rem}`}>
								<Text className={styles.lookUpLabel}>Por Nombre:</Text>
								<Dropdown
									fluid
									name="tagsSelected"
									value={tagsSelected}
									onChange={handleInputDropdown}
									options={
										!isEmpty(categoriesSelected)
											? (isArray(tagsData) ? tagsData : []).filter((tag) => {
													return includes(categoriesSelected, tag.categoryId);
											  })
											: tagsData
									}
									handleSelection={handleTipyfication}
									placeholder="Seleccionar"
									size="mini"
									search
									upward
									multiple
									selection
									clearable
									selected
									renderLabel={renderLabelPlatforms}
								/>
							</div>
						</div>
					</fieldset>
				</div>
			</Grid>
		</IKModal>
	);
};

ActionUserCrud.propTypes = {
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	setPlatformfilters: PropTypes.func,
	groupsfilters: PropTypes.array,
	setGroupsfilters: PropTypes.func,
	tagsSelected: PropTypes.array,
	setTagsSelected: PropTypes.func,
	categoriesSelected: PropTypes.array,
	setCategoriesSelected: PropTypes.func,
	startDate: PropTypes.string,
	setStartDate: PropTypes.func,
	endDate: PropTypes.string,
	setEndDate: PropTypes.func,
	contacts: PropTypes.object,
	setContacts: PropTypes.func,
	agents: PropTypes.array,
	setAgents: PropTypes.func,
	note: PropTypes.string,
	setNote: PropTypes.func,
	options: PropTypes.array,
	setSeletedFilteres: PropTypes.func,
	seletedFilteres: PropTypes.array,
	dateField: PropTypes.string,
	setDateField: PropTypes.func,
	onApplyFilters: PropTypes.func,
	channelFilters: PropTypes.string,
	setChannelFilters: PropTypes.func,
	channels: PropTypes.object,
	stateValue: PropTypes.string,
	setStateValue: PropTypes.func,
	orderBy: PropTypes.string,
	setOrderBy: PropTypes.func,
	orderDirection: PropTypes.string,
	setOrderDirection: PropTypes.func,
	setTabValue: PropTypes.func,
	includeClosed: PropTypes.bool,
	setIncludeClosed: PropTypes.func,
	originValue: PropTypes.array,
	setOriginValue: PropTypes.func,
	// companyFields: PropTypes.array,

	// selectedFields: PropTypes.array,
	// setSelectedFields: PropTypes.func,

	// listItemsSelected: PropTypes.array,
	// setListItemsSelected: PropTypes.func,
};

function mapStateToProps({ chats, company, user }) {
	return {
		companyFields: company.companyFields || [],
		reply: chats.reply,
		channels: company.channels,
		user,
	};
}

export default connect(mapStateToProps)(ActionUserCrud);
